import React from "react"
import { createRoot } from "react-dom/client"
import App from "./App"
import "./styles/global.css"
import "./styles/landing.css"

createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
